import * as React from 'react';
import { useState, useContext } from 'react';
import { Grid, Fab, Dialog, useTheme, Zoom } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';

import ContactCard from './ContactCard';
import { ContactContext } from '../store/contactContext';
import ContactForm from './ContactForm';

const useStyles = makeStyles((theme: Theme) => ({
  fab: {
    position: 'fixed',
    right: 20,
    bottom: 20,
  },
  lastCard: {
    marginBottom: theme.spacing(10),
  },
}));

type Props = {
  contacts: Contact[];
  loading: boolean;
};

const ContactListMobile: React.FC<Props> = ({ contacts, loading }: Props) => {
  const classes = useStyles();
  const [adding, setAdding] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();
  const { addContact, getContacts, addContactLoading } = useContext(
    ContactContext
  );

  const handleAddSubmit = (data: ContactFormDto) => {
    addContact(data, () => {
      setAdding(false);
      getContacts(true);
    });
  };

  const handleAddOpen = () => {
    setAdding(true);
  };

  const handleAddClose = () => {
    setAdding(false);
  };

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };

  return (
    <Grid container spacing={3}>
      {contacts.map((c, index) => (
        <Grid
          key={c.id}
          item
          xs={12}
          className={index === contacts.length - 1 ? classes.lastCard : ''}
        >
          <ContactCard contact={c} loading={loading} />
        </Grid>
      ))}
      <Zoom in timeout={transitionDuration} unmountOnExit>
        <Fab
          className={classes.fab}
          color="primary"
          aria-label="add"
          onClick={handleAddOpen}
        >
          <AddIcon />
        </Fab>
      </Zoom>
      <Dialog open={adding} onClose={handleAddClose}>
        <ContactForm
          onSubmit={handleAddSubmit}
          buttonText={t('common:add')}
          loading={addContactLoading}
          cancelButton
          onCancel={handleAddClose}
        />
      </Dialog>
    </Grid>
  );
};

export default ContactListMobile;
